import {UserFilter} from "@/api/modules/userManagement/UserFilter";
import {UserService} from "@/api/modules/userManagement/services/UserService";
import {User} from "@/api/modules/userManagement/models/User";

export class UserManagement {

    constructor(auth) {
            if (auth == null) {
                throw new Error("[e70101] auth missing on UserManagement");
            }

            this.auth = auth;
            this.service = new UserService(this.auth);
    }

    /**
     * getUsers Returns a collection of users that match the filters.
     *
     * @param companyId Filters by the company Id, if empty string, then it is ignored.
     * @param account Filters by the account, if empty string, then it is ignored
     * @param role Filters by Role, if empty string, then it is ignored.
     * @param isActive Filters by isActive status, is null then it is ignored.
     * @returns {Promise<Users[]>}
     */
    getUsers(companyId, account, role, isActive) {

        return new Promise((resolve, reject) => {

            if (companyId == null){
                companyId = "";
            }
            if (account == null){
                account = "";
            }
            if (role == null){
                role = "";
            }

            let filter = new UserFilter(companyId, account, role, isActive);

            this.service.getUsers(filter).then(users => {
                resolve(users);

            }).catch(e => {

                window.tracer.error("[e264607-ADM] error retrieving users.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });
        });
    }


    getUserRoles(userId){
        return new Promise((resolve, reject) => {
            try{
                this.service.getUserRoles(userId).then(roles =>{

                    resolve(roles);

                }).catch(e =>{

                    window.tracer.error(`[e288972-ADM] Error getting roles for user ${userId}`)
                    if (e != null) {
                        window.tracer.error(e);
                    }

                    reject(e);
                })
            }
            catch(e){
                window.tracer.error(`[e254292-ADM] Error getting roles for user ${userId}`)
                window.tracer.error(e);
                reject(e);
            }

        });
    }

    /**
     * Get all available defined roles
     * @returns {Promise<Role[]>}
     */
    getRoles(){
        return new Promise((resolve, reject) => {

            this.service.getRoles().then(roles => {

                if (roles == null || roles === false){
                    throw new Error(`[e563942-ADM] Failed to get user roles.`);
                }

                resolve(roles);

            }).catch(e => {

                window.tracer.error("[e963628-ADM Error retrieving roles from server.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });
        });
    }

    searchAccounts(searchString){
        return new Promise((resolve, reject) => {

            this.service.searchAccounts(searchString).then(accounts => {
                resolve(accounts);

            }).catch(e => {

                window.tracer.error("[e223020-ADM] Error searching for accounts.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });
        });
    }

    createUser(user, password){

        return new Promise((resolve, reject) => {

            if (user == null){
                throw new Error("[e695979-ADM] user cannot be a null object");
            }

            if ( (!user instanceof  User)){
                throw new Error("[647909-ADM] user must be instance of User");
            }

            this.service.createUser(user, password).then(id => {

                if (id == null){
                    window.tracer.warn("[w246134-ADM] expected identifier not returned when creating a new user.");
                    reject();
                }
                else {
                    resolve(id)
                }
            }).catch(e => {
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });

        });
    }

    updateUser(user) {
        return new Promise((resolve, reject) => {

            if (user == null) {
                throw new Error("[e789613-ADM] user cannot be a null object");
            }

            if (!(user instanceof User)) {
                throw new Error("[e733715-ADM] user must be instance of User");
            }

            try {
                this.service.updateUser(user).then(() => {
                    resolve();
                }).catch(e => {
                    if (e != null) {
                        window.tracer.error(e);
                    }

                    reject(e);
                });
            } catch (e) {

                window.tracer.error("[e479277-ADM] Error updating user")
                reject(e);
            }

        });
    }

    changePassword(userId, password){

        return new Promise((resolve, reject) => {

            if (userId == null){
                throw new Error("[e635053-ADM] Expected a valid userId. The userId is null");
            }

            if (password == null || password.length == 0){
                throw new Error("[e862015-ADM] Expected a password. The password is empty string or null value");
            }

            this.service.changePassword(userId, password).then(result =>{

                if (result == null || result === false){
                    throw new Error(` Failed to change password. The user id  ${userId} not found`);
                }

                resolve();

            }).catch(e => {
                window.tracer.error("[e780106-ADM] Error updating password.")
                if (e != null) {
                    window.tracer.error(e);
                }
                reject(e);
            });


        });

    }

    /**
     * Adds a role to an user
     * @param userId The user Id
     * @param roleName The role name
     * @returns {Promise<unknown>}
     * @exception if userId or roleName are undefined or empty string.
     */
    addRole(userId, roleName) {

        if (userId == null || userId.length == 0) {
            throw new Error("[e409421-ADM] userId is empty or undefined");
        }

        if (roleName == null || roleName.length == 0) {
            throw new Error("[e722090-ADM] roleName is empty or undefined");
        }

        return new Promise((resolve, reject) => {
            try {
                this.service.addRole(userId, roleName).then(() => {
                    resolve();
                }).catch(e => {

                    window.tracer.error("[e116026-ADM] Error adding role ")
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });
            } catch (e) {

                window.tracer.error(e);
                window.tracer.error("[e425718-ADM] Error adding roles")
                reject(e);
            }

        });

    }

    /**
     * Removes a role from an user
     * @param userId The user Id
     * @param roleName The role name (not the id)
     * @returns {Promise<>}
     * @exception if userId or roleName are undefined or empty string.
     */
    removeRole(userId, roleName){

        if (userId == null || userId.length == 0) {
            throw new Error("[e732244-ADM] userId is empty or undefined");
        }

        if (roleName == null || roleName.length == 0) {
            throw new Error("[e181245-ADM] roleName is empty or undefined");
        }

        return new Promise((resolve, reject) => {
            try{
                this.service.removeRole(userId, roleName).then(() =>{
                    resolve();
                }).catch(e => {

                    window.tracer.error("[e279763-ADM] Error removing role ")
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });
            }
            catch(e){

                window.tracer.error("[e940418-ADM] Error removing role");
                reject(e);
            }

        });

    }

    /**
     * Activates a user
     * @param userId - The user id
     * @returns {Promise<()>}
     */
    activateUser(userId){

        return new Promise((resolve, reject) => {
            try{
                this.service.activateUser(userId).then(() =>{
                    resolve();
                }).catch(e => {
                    window.tracer.error("[e300917-ADM] Error activating user");
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                })
            }
            catch(e){

                window.tracer.error("[e899004-ADM] Error activating user");
                window.tracer.error(e);
                reject(e);
            }

        });

    }

    /**
     * Deactivate a user
     * @param userId - The user id
     * @returns {Promise<()>}
     */
    deactivateUser(userId){
        return new Promise((resolve, reject) => {
            try{
                this.service.deactivateUser(userId).then(() =>{
                    resolve();
                }).catch(e => {
                    window.tracer.error("[e708431-ADM] Error activating user")
                    reject(e);
                })
            }
            catch(e){

                window.tracer.error("[e361722-ADM] Error activating user")
                reject(e);
            }

        });

    }

    checkUsername(username){
        return new Promise((resolve, reject) => {
            try{
                this.service.isUsernameAvailable(username).then(result => {
                    resolve(result);
                }).catch(e =>{
                    window.tracer.error("[e209322-ADM] Error checking for availability of the username");
                    if (e != null) {
                        window.tracer.error(e);
                    }
                    reject(e);
                });
            }
            catch(e){

                window.tracer.error("[e146609-ADM] Error while checking the if the username exists")
                reject(e);
            }

        });
    }

    /**
     * Returns the list of companies. This is ASP and AER
     * @returns {Promise<Company>}
     */
    getCompanies(){
        return new Promise((resolve, reject) => {

            this.service.getCompanies().then(c => {

                if (c == null || c === false){
                    throw new Error(`[e163079-ADM] Error getting company list from server.`);
                }

                resolve(c);

            }).catch(e => {

                window.tracer.error("[e263066-ADM] Error getting company from server.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });
        });
    }

    /**
     * Returns the list of companies. This is ASP and AER
     * @returns {Promise<Branch>}
     */
    getCompanyBranches(companyId){

        return new Promise((resolve, reject) => {

            if (companyId == null || companyId.length === 0){

                throw new Error("[e598040-ADM] company id is empty string or null. Invalid value for requesting company branches.");
            }

            this.service.getCompanyBranches(companyId).then(branches => {

                if (branches == null || branches === false){
                    throw new Error(`[e752585-ADM] Error getting company branches from server.`);
                }

                resolve(branches);

            }).catch(e => {

                window.tracer.error("[e294792-ADM] Error getting company branches from server.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });
        });
    }





}

